import React from "react";
import styled, { css } from "styled-components";
import { px2rem } from "../../../ezUI/StyledComponents/utils";
import Constant, { CountryIConPosition, setCookie, Host, comCookieLocal } from "../../../utils/constant";
import getLangKeyValueFun from "../../../utils/lang";
import { AssetImageUrl } from "../../../assets/imgUrl";
import langGroup from "../../../assets/lang.json";
const gettext = getLangKeyValueFun(langGroup);
const Container = styled.div `
	position: fixed;
	width: 100%;
	height: 100%;
	top: 0;
	z-index: 3000;
	background: #ffffff;
	font-size: ${px2rem(16)};
	color: #333333;
	padding-top: ${px2rem(106)};
	box-sizing: border-box;
`;
const Header = styled.div `
	position: fixed;
	top: 0;
	width: 100%;
	height: ${px2rem(50)};
	padding: 0 ${px2rem(13.5)};
	box-sizing: border-box;
	z-index: 10;
	> div {
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
	}
`;
const List = styled.div `
	position: absolute;
	width: 100%;
	height: 100%;
	overflow: scroll;
	background: #fff;
	padding-bottom: ${px2rem(105)};
	box-sizing: border-box;
`;
const Close = styled.div `
	position: absolute;
	top: 50%;
	left: ${px2rem(12)};
	transform: translateY(-50%);
`;
const Title = styled.div `
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	font-weight: 800;
	font-size: ${px2rem(18)};
`;
const Search = styled.div `
	position: fixed;
	top: ${px2rem(50)};
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 0 ${px2rem(13.5)};
	color: #333;
	font-size: ${px2rem(14)};
	margin-bottom: ${px2rem(17)};
	z-index: 10;
	box-sizing: border-box;
`;
const SearchInput = styled.div `
	flex: 1;
	position: relative;
	> input {
		border: none;
		width: 100%;
		background: #f0f0f0;
		border-radius: 0.375rem;
		padding: 0 1.625rem 0 2.125rem;
		height: 2.0625rem;
		box-sizing: border-box;
		tap-highlight-color: transparent;
		-webkit-tap-highlight-color: transparent;
		outline: none;
	}
	> img {
		position: absolute;
		left: 0.5625rem;
		top: 0.5rem;
	}
`;
const Cancel = styled.div `
	margin-left: ${px2rem(13.5)};
`;
const CountryTitle = styled.div `
	padding: 0 ${px2rem(13.5)};
	font-size: ${px2rem(16)};
	font-weight: 700;
`;
const LetterTitle = styled(CountryTitle) `
	padding: 0 ${px2rem(13.5)};
	font-size: ${px2rem(16)};
	font-weight: 700;
	height: ${px2rem(50)};
	line-height: ${px2rem(50)};
`;
const CountryItem = styled.div `
	display: flex;
	align-items: center;
	justify-content: space-between;
	height: ${px2rem(50)};
	margin-left: ${px2rem(13.5)};
	padding-right: ${px2rem(13.5)};
	> img {
		display: none;
	}
	${(props) => props.checked &&
    css `
			color: #e33124;
			> img {
				display: block;
			}
		`};
	${(props) => !props.noBorderBottom &&
    css `
			border-bottom: 1px solid #dedede;
		`};
`;
const ItemLeft = styled.div `
	display: flex;
	align-items: center;
	> em {
		width: ${px2rem(40)};
		font-style: normal;
	}
`;
const CountryIcon = styled.div `
	width: ${px2rem(24)};
	height: ${px2rem(16)};
	background-image: url(https://lijc.rightinthebox.com/jupiter_lightsource/img/icon_header_country_flag.png);
	background-repeat: no-repeat;
	margin-right: ${px2rem(13.5)};
	background-position: 100px 100px;
`;
class Country extends React.Component {
    constructor(props) {
        super(props);
        this.searchInput = e => {
            this.setState({
                searchText: e.target.value || ""
            }, () => {
                if (this.state.searchText) {
                    this.searchCountry(this.state.searchText);
                }
            });
        };
        this.searchCountry = value => {
            const { countries = [] } = this.props;
            const filterList = countries.filter(item => {
                const searchIndex = item.countryName
                    .toLocaleLowerCase()
                    .indexOf(value.toLocaleLowerCase());
                if (searchIndex === 0) {
                    return true;
                }
            });
            this.setState({ filterList });
        };
        this.cancel = () => {
            this.setState({
                showCancel: false,
                searchText: ""
            });
        };
        this.change = (country) => {
            const BaseUrl = Host[String(Constant.isUat)];
            const domain = Constant.isDev ? "" : BaseUrl.domain;
            const cookieLocal = comCookieLocal([
                Constant.language,
                country.countryIsoCode2,
                country.defaultCurrency
            ]);
            setCookie("local", cookieLocal, "/", domain);
            setCookie("ci-country", country.countryId, "/", domain);
            setCookie("ci-currency", country.defaultCurrency || "USD", "/", domain);
            location.reload();
        };
        const { countries = [], popularCountries = [] } = props;
        this.state = {
            showCancel: false,
            searchText: "",
            allCountry: [...countries, ...popularCountries],
            filterList: []
        };
    }
    render() {
        const { showCancel, searchText, allCountry, filterList } = this.state;
        const { stateChange, currentCountry, popularCountries, countries } = this.props;
        return (React.createElement(Container, null,
            React.createElement(Header, null,
                React.createElement(Close, { onClick: () => stateChange(`showCountryModal`, false) },
                    React.createElement("img", { src: AssetImageUrl["ic_back@3x.png"], width: 24 })),
                React.createElement(Title, null, gettext("Ship to"))),
            React.createElement(Search, null,
                React.createElement(SearchInput, null,
                    React.createElement("input", { value: searchText, placeholder: gettext("Search"), onFocus: () => this.setState({ showCancel: true }), onChange: this.searchInput }),
                    React.createElement("img", { src: AssetImageUrl["ic_search@3x.png"], width: 18 })),
                showCancel && React.createElement(Cancel, { onClick: this.cancel }, "Cancel")),
            React.createElement(List, null,
                React.createElement("div", null,
                    React.createElement(CountryTitle, null, gettext("Current Country")),
                    React.createElement(CountryItem, { noBorderBottom: true, checked: true },
                        React.createElement(ItemLeft, null,
                            React.createElement(CountryIcon, { style: {
                                    backgroundPosition: CountryIConPosition[currentCountry.countryIsoCode2]
                                } }),
                            React.createElement("span", null, currentCountry.countryName)),
                        React.createElement("img", { src: AssetImageUrl["ic_right@3x.png"], width: 24 })),
                    React.createElement(CountryTitle, null, gettext("Popular Country")),
                    popularCountries.map((item, index) => {
                        return (React.createElement(CountryItem, { key: item.countryId, noBorderBottom: index === popularCountries.length - 1, onClick: () => this.change(item) },
                            React.createElement(ItemLeft, null,
                                React.createElement(CountryIcon, { style: {
                                        backgroundPosition: CountryIConPosition[item.countryIsoCode2]
                                    } }),
                                React.createElement("span", null, item.countryName)),
                            React.createElement("img", { src: AssetImageUrl["ic_right@3x.png"], width: 24 })));
                    }),
                    countries.map((item, index) => {
                        if (Constant.language === "en") {
                            let hasTitle = false;
                            let nextFirstLetter = "";
                            if (item &&
                                item.countryName &&
                                allCountry[index + 1] &&
                                allCountry[index + 1].countryName) {
                                const currentFirstLetter = item.countryName[0];
                                nextFirstLetter = allCountry[index + 1].countryName[0];
                                if (currentFirstLetter !== nextFirstLetter) {
                                    hasTitle = true;
                                }
                            }
                            return (React.createElement(React.Fragment, { key: item.countryId },
                                index === 0 ? (React.createElement(LetterTitle, null, nextFirstLetter)) : null,
                                React.createElement(CountryItem, { noBorderBottom: hasTitle, onClick: () => this.change(item) },
                                    React.createElement(ItemLeft, null,
                                        React.createElement(CountryIcon, { style: {
                                                backgroundPosition: CountryIConPosition[item.countryIsoCode2]
                                            } }),
                                        React.createElement("span", null, item.countryName)),
                                    React.createElement("img", { src: AssetImageUrl["ic_right@3x.png"], width: 24 })),
                                hasTitle ? (React.createElement(LetterTitle, null, nextFirstLetter)) : null));
                        }
                        else {
                            return (React.createElement(React.Fragment, { key: item.countryId },
                                React.createElement(CountryItem, { onClick: () => this.change(item) },
                                    React.createElement(ItemLeft, null,
                                        React.createElement(CountryIcon, { style: {
                                                backgroundPosition: CountryIConPosition[item.countryIsoCode2]
                                            } }),
                                        React.createElement("span", null, item.countryName)),
                                    React.createElement("img", { src: AssetImageUrl["ic_right@3x.png"], width: 24 }))));
                        }
                    }))),
            !!searchText && searchText.length > 0 && (React.createElement(List, null, filterList.map(item => {
                return (React.createElement(CountryItem, { key: item.countryId, noBorderBottom: false, onClick: () => this.change(item) },
                    React.createElement(ItemLeft, null,
                        React.createElement(CountryIcon, { style: {
                                backgroundPosition: CountryIConPosition[item.countryIsoCode2]
                            } }),
                        React.createElement("span", null, item.countryName)),
                    React.createElement("img", { src: AssetImageUrl["ic_right@3x.png"], width: 24 })));
            })))));
    }
}
export default Country;
